import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { API_USAGE } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { ApiUsageResponseType } from 'src/app/types/response/api-usage.response.type';

@Component({
  selector: 'app-api-usage',
  standalone: false,
  templateUrl: './api-usage.component.html',
  styleUrl: './api-usage.component.scss'
})
export class ApiUsageComponent {
  loading = true;
  apiUsageData: ApiUsageResponseType | null = null

  constructor(
    private baseService: BaseService,
    private message: NzMessageService,
  ) { }
  
  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    this.getApiUsage();
  }

  getApiUsage() {
    this.baseService.getData(API_USAGE).subscribe({
      next: (res) => {
        this.apiUsageData = res.data;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error('Error fetching API usage data:', err);
        this.message.error('Failed to load API usage data');
      }
    });
  }

  usagePercent(): string {
    const usage = this.apiUsageData?.daily_usage ?? 0;
    const limit = this.apiUsageData?.daily_limit ?? 0;
    const percent = limit > 0 ? (usage / limit) * 100 : 0;
    return `${percent}%`;
  }
}
